export default __webpack_public_path__ + "static/accredited-business-logo-9464dfe22ae098a29e8c8b377faf0c7c.webp";